"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Periods = void 0;
const lodash_1 = require("lodash");
const dateUtil_1 = require("./dateUtil");
const period_1 = require("./period");
const periodJoiner_1 = require("./periodJoiner");
class Periods {
    constructor(periods) {
        this.periods = periods;
    }
    /**
     * 引数で指定したPeriodsとAND条件で計算したPeriodsを返す
     * @param target Periods
     * @returns AND条件の計算結果のPeriods
     */
    and(target) {
        const result = this.periods.map((p) => {
            const ips = target.periods.map((tp) => {
                return p.and(tp);
            });
            return (0, lodash_1.compact)(ips);
        });
        return new Periods((0, lodash_1.flatten)(result));
    }
    /**
     * 引数で指定したPeriodsとAND条件で計算したPeriodsを返す
     * @param target Periods
     * @returns AND条件の計算結果のPeriods
     */
    or(target, lengthMin) {
        if ((0, lodash_1.isEmpty)(target.periods)) {
            return this;
        }
        if ((0, lodash_1.isEmpty)(this.periods)) {
            return target;
        }
        const result = this.periods.map((p) => {
            const ips = target.periods.map((tp) => {
                return p.or(tp, lengthMin);
            });
            return (0, lodash_1.flatten)(ips);
        });
        // 総組み合わせで重複がめちゃくちゃ多くなるのでまずUniqかける
        const periods = (0, lodash_1.uniq)((0, lodash_1.flatten)(result));
        // それでも不要なPeriodが残るのでJoinしてまとめる
        // 被りの時間未満のものはJoinされてほしくないので、-lengthMin
        // をつけることでJoinされなようにする
        // ここの計算量が気になる...
        return periodJoiner_1.PeriodJoiner.joinPeriods(new Periods(periods), -lengthMin);
    }
    /**
     * 引数で指定したPeriodsをNOT条件で計算したPeriodsを返す。
     * @param periods Periods
     * @returns NOT条件の計算結果のPeriods
     */
    not(target) {
        const periods = this.periods.map((p) => {
            const overLappedTp = target.periods.filter((tp) => (0, dateUtil_1.isOverlap)(p, tp));
            if ((0, lodash_1.isEmpty)(overLappedTp)) {
                // 被りがない場合はこれがそのまま結果になる
                return [p];
            }
            else {
                let result = [];
                // accに対して再起的にnotをかける
                let acc = p;
                for (const [i, tp] of overLappedTp.entries()) {
                    // NOT演算
                    const res = acc.not(tp);
                    // nullの場合
                    if (res === null) {
                        // 空配列でbreak
                        result = [];
                        break;
                    }
                    // Period[]の場合
                    if ((0, lodash_1.isArray)(res)) {
                        // 結果から再度Periodsを作る
                        const resPeriods = new Periods(res);
                        // まだ計算していないtargetPeriodsからPeriodsを作る
                        const remainPeriods = new Periods(overLappedTp.slice(i + 1));
                        // それらに対して再起的にnot演算をかけてbreak
                        result = resPeriods.not(remainPeriods).periods;
                        break;
                    }
                    // Periodの場合
                    // accを更新
                    acc = res;
                    // 結果にaccをセット
                    result = [acc];
                }
                return result;
            }
        });
        return new Periods((0, lodash_1.flatten)(periods));
    }
    join(target) {
        const periodArray = this.periods.concat(target.periods);
        return new Periods(periodArray);
    }
    convertTZ(originTZ, targetTZ) {
        this.periods = this.periods.map((p) => p.convertTZ(originTZ, targetTZ));
        return this;
    }
    excludeLessThanMinutes(minutes) {
        const periods = this.periods.filter((p) => p.lengthInMinutes() >= minutes);
        return new Periods(periods);
    }
    narrowDownMinutes(minutes) {
        const periods = this.periods.map((p) => p.narrowDownMinutes(minutes));
        return new Periods((0, lodash_1.compact)(periods));
    }
    expandMinutes(minutes) {
        const periods = this.periods.map((p) => p.expandMinutes(minutes));
        return new Periods(periods);
    }
    /**
     * 引数のPeriod内のSubsetのみにフィルターする
     * @param period
     * @returns
     */
    filterSubsetOf(period) {
        const periods = this.periods.filter((p) => p.isSubsetOf(period));
        return new Periods(periods);
    }
    isEmpty() {
        return (0, lodash_1.isEmpty)(this.periods);
    }
    hasPeriods() {
        return !(0, lodash_1.isEmpty)();
    }
    /**
     * thisが引数で渡したperiodのSupersetかどうか。
     * Period/Periodsはあくまでも日程調整に関係ない時間の範囲を表す
     * クラスなので、集合のSupersetという言葉を使っているが、要は含まれるかどうかということ
     * @param period
     * @see
     * https://www.nli-research.co.jp/report/detail/id=63317?site=nli
     */
    isSupersetOf(period) {
        return this.periods.some((p) => p.isSupersetOf(period));
    }
    findSuperSetOf(period) {
        return this.periods.find((p) => p.isSupersetOf(period));
    }
    /**
     * タイムスタンプから生成
     * @param timeStampPeriod
     * @returns
     */
    static fromTimeStamp(timeStampPeriods) {
        return new Periods(timeStampPeriods.map((tp) => period_1.Period.fromTimeStamp(tp)));
    }
    // 最初のPeriod
    get firstPeriod() {
        return (0, lodash_1.first)(this.periods);
    }
    // 最後のPeriod
    get lastPeriod() {
        return (0, lodash_1.last)(this.periods);
    }
    get planeObjectArray() {
        return this.periods.map((p) => p.planeObject);
    }
}
exports.Periods = Periods;
//# sourceMappingURL=periods.js.map